export const ScanSystemTypes = {
  Element: 'Element',
  '5D': '5D',
  Lumina: 'Lumina',
  LuminaPro: 'LuminaPro',
};
